import './cta-block.scss';
export default (() => {
  $(window).on('load scroll', function () {
    let parallaxElement = $('.js-parallax-slide');
    let parallaxQuantity = parallaxElement.length;
    window.requestAnimationFrame(function () {
      for (let i = 0; i < parallaxQuantity; i++) {
        let currentElement = parallaxElement.eq(i);
        let windowTop = $(window).scrollTop();
        let elementTop = currentElement.offset().top;
        let elementHeight = currentElement.height();
        let viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5;
        let scrolled = windowTop - elementTop + viewPortHeight;
        currentElement.css({
          transform: `skew(0deg) translate3d(0,${scrolled * -0.07}px, 0)`
        });
      }
    });
  });
  $(window).on('load scroll', function () {
    let parallaxElement = $('.js-parallax-slide-1');
    let parallaxQuantity = parallaxElement.length;
    window.requestAnimationFrame(function () {
      for (let i = 0; i < parallaxQuantity; i++) {
        let currentElement = parallaxElement.eq(i);
        let windowTop = $(window).scrollTop();
        let elementTop = currentElement.offset().top;
        let elementHeight = currentElement.height();
        let viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5;
        let scrolled = windowTop - elementTop + viewPortHeight;
        currentElement.css({
          transform: `skew(0deg) translate3d(0,${scrolled * -0.1}px, 0)`
        });
      }
    });
  });
  $(window).on('load scroll', function () {
    let parallaxElement = $('.js-parallax-slide-2');
    let parallaxQuantity = parallaxElement.length;
    window.requestAnimationFrame(function () {
      for (let i = 0; i < parallaxQuantity; i++) {
        let currentElement = parallaxElement.eq(i);
        let windowTop = $(window).scrollTop();
        let elementTop = currentElement.offset().top;
        let elementHeight = currentElement.height();
        let viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5;
        let scrolled = windowTop - elementTop + viewPortHeight;
        currentElement.css({
          transform: `skew(0deg) translate3d(0,${scrolled * -0.2}px, 0)`
        });
      }
    });
  });
  $(window).on('load scroll', function () {
    let parallaxElement = $('.js-parallax-slide-3');
    let parallaxQuantity = parallaxElement.length;
    window.requestAnimationFrame(function () {
      for (let i = 0; i < parallaxQuantity; i++) {
        let currentElement = parallaxElement.eq(i);
        let windowTop = $(window).scrollTop();
        let elementTop = currentElement.offset().top;
        let elementHeight = currentElement.height();
        let viewPortHeight = window.innerHeight * 0.7 - elementHeight * 0.7;
        let scrolled = windowTop - elementTop + viewPortHeight;
        currentElement.css({
          transform: `skew(0deg) translate3d(0,${scrolled * -0.15}px, 0)`
        });
      }
    });
  });
});